import { CutOffList } from '@components/cutOffList';
import { Widget } from '@widgets/widget';

export const TypeMap: Record<string, React.ComponentType<any>> = {
  CutOffList,
  Widget,
};
